import * as CryptoJS from 'crypto-js';

export function getFormattedDate(value: string): string {
  if (!value) return '';
  const parts = value.split(' ');
  if (parts.length !== 3) return value;

  const monthsMap: { [key: string]: string } = {
    jan: '01', feb: '02', mar: '03', apr: '04', may: '05', jun: '06',
    jul: '07', aug: '08', sep: '09', oct: '10', nov: '11', dec: '12'
  };

  const day = parts[0].padStart(2, '0');
  const month = monthsMap[parts[1].toLowerCase().substring(0, 3)];
  const year = parts[2];

  return `${month}/${day}/${year}`;
}
export function getFormattedAge(inputDate: string): string {
    if (!inputDate) return '';

    const birthDate = new Date(inputDate);
    if (isNaN(birthDate.getTime())) return '';

    const today = new Date();
    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    // Adjust for birthday not reached yet this year
    if (months < 0 || (months === 0 && days < 0)) {
      years--;
      months += 12;
    }

    // Adjust days if negative
    if (days < 0) {
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
      months--;
      if (months < 0) {
        months += 12;
        years--;
      }
    }

    const parts = [];
    if (years > 0) parts.push(`${years} years`);
    if (months > 0) parts.push(`${months} months`);
    if (days > 0) parts.push(`${days} days`);

    return parts.join(', ') || '0 days';
  }

  export function dateRange(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear();
    
    return `${year}-${month}-${day}`;
  }

  export function generateGuid(): string {
    // return crypto.randomUUID();
    const timestamp = new Date().getTime().toString(36);
    const randomStr = Math.random().toString(36).substring(2, 8);
    return `${timestamp}-${randomStr}`;
  }
  

  export function onlyNumbers(event: KeyboardEvent) {
    const charCode = event.key;
    // Allow only 0-9 and one dot
    const isNumber = /[0-9]/.test(charCode);
    const isDot = charCode === '.';
    const hasDot = (event.target as HTMLInputElement).value.includes('.');
    if (!isNumber && !(isDot && !hasDot)) {
      event.preventDefault(); // This kills the alphabet key before it prints
    }
  }

  export function calculateHashForRequest(responseModel: any): string {
    try {
      let secretKey = "qpydp28JC53Xi6wdVodg/4t2mPWGp/8zIHXjb/8M";
 
      // Convert object to JSON string
      let jsonString = JSON.stringify(responseModel);
      
      // Generate HMAC SHA256 hash
      let hashValue: any = CryptoJS.HmacSHA256(jsonString, secretKey);
      const hashInBase64 = CryptoJS.enc.Base64.stringify(hashValue);
      return hashInBase64;
    } catch (error) {
      return '';
    }
  }